module.exports = __webpack_public_path__ + "img/eldorTrLogo.354f39d7.png";